import { callIcon, mailIcon } from "../../assets";
import { motion } from "framer-motion";

const SecondCard = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="relative max-w-[40rem] mx-auto mt-12 mb-8 px-8 py-10 bg-gradient-to-r from-[#0ea5e9] to-[#0284c7] text-white rounded-3xl shadow-xl overflow-hidden"
    >
      {/* Subtle background glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent opacity-20 pointer-events-none"></div>


      {/* Header */}
      <h1 className="text-3xl font-bold mb-3 tracking-wide">
        Have Any Questions?
      </h1>

      <p className="text-lg text-blue-50 mb-6 leading-relaxed">
        We’re always happy to hear from you! Whether it’s a course inquiry or
        partnership opportunity, our team is just one click away.
      </p>

      {/* Contact Info */}
      <div className="space-y-4">
        {/* Phone Section */}
        <div className="flex items-start gap-3">
          <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">
            <img src={callIcon} alt="Call Icon" className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm opacity-80">Call Us</p>
            <div className="font-medium text-lg">
              {/* <a href="tel:09031693655" className="hover:underline">
                09031693655
              </a>
              ,{" "} */}
              <a href="tel:08084259372" className="hover:underline">
                08084259372
              </a>
              ,{" "}
              <a href="tel:08115371014" className="hover:underline">
                08115371014
              </a>
            </div>
          </div>
        </div>

        {/* Email Section */}
        <div className="flex items-start gap-3">
          <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm">
            <img src={mailIcon} alt="Mail Icon" className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm opacity-80">Email Us</p>
            <a
              href="mailto:info@zulfahgroup.com"
              className="text-lg font-medium hover:underline"
            >
              info@zulfahgroup.com
            </a>
          </div>
        </div>
      </div>

      {/* Glow Effect at the Bottom */}
      <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-cyan-300 rounded-full blur-3xl opacity-20"></div>
    </motion.div>
  );
};

export default SecondCard;
